import { css, styled } from 'styled-components';

import type { ApiListingLocationType } from 'api/types/ApiListingLocationType';
import { Icon } from 'components/Icon/Icon';
import { Tag } from 'components/Tag/Tag';
import type { Color } from 'theme/theme';
import { colors } from 'theme/theme';

type Props = {
  locationType: ApiListingLocationType;
  location: string;
};

const LocationTypeColorMap = {
  REMOTE: 'brightPlum',
  HYBRID: 'secondarySkyBlue',
  ONSITE: 'brandGreen',
} satisfies Record<ApiListingLocationType, Color>;

const StyledTag = styled(Tag)<{ $locationType: ApiListingLocationType }>`
  & span:nth-child(2) {
    white-space: normal !important;
  }

  ${({ $locationType }) => {
    if ($locationType === 'REMOTE')
      return css`
        border-color: ${colors[LocationTypeColorMap.REMOTE]};
      `;

    if ($locationType === 'HYBRID')
      return css`
        border-color: ${colors[LocationTypeColorMap.HYBRID]};
      `;

    if ($locationType === 'ONSITE')
      return css`
        border-color: ${colors[LocationTypeColorMap.ONSITE]};
      `;
  }};
`;

export function ListingLocationLabel({ locationType, location }: Props) {
  return (
    <StyledTag
      $locationType={locationType}
      size="micro"
      prefix={
        <Icon
          name="location-filled"
          colorName={LocationTypeColorMap[locationType]}
          size={14}
        />
      }
    >
      {location}
    </StyledTag>
  );
}
